export default function handleAnalyticsClicks() {
    $('body').on('click', 'a[href^="mailto:"]', function (e) {
        return gtag_report_mail_conversion($(this).attr('href'));
    }).on('click', 'a[href^="tel:"]', function () {
        gtag_report_tel_conversion($(this).attr('href'));
    });
}

function gtag_report_mail_conversion(url) {
    console.log('report mail');
    try {
        dataLayer.push({
            'event': 'email-click',
        });

        gtag('event', 'conversion', {
            'send_to': 'AW-16521779395/qSHUCO680acZEMOxmcY9', 'event_callback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
        window.location.href = url;
    }
    return false;
}

function gtag_report_tel_conversion(url) {
    console.log('report tel');
    try {
        dataLayer.push({
            'event': 'phone-click',
        });

        gtag('event', 'conversion', {
            'send_to': 'AW-16521779395/KmMNCMmv0KcZEMOxmcY9', 'event_callback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
        window.location.href = url;
    }
}